export default "__VITE_ASSET__Xbd7qcD4__"